import SlsTracker from '@aliyun-sls/web-track-browser'
import createStsPlugin from '@aliyun-sls/web-sts-plugin'
import { baseApi } from '@/v2/utils/api'
import store from '@/vuex/store'
import { domain } from '@/config'
export default {
  init,
  send,
  reInit,
  httpLog,
  getRequestId,
  checkSlsUrl
}

const slsUrls = [
  // 获取批阅最新试题
  /^post:\/marking-exam-grading\/grading\/question\/item$/,
  // 更新批阅得分
  /^put:\/marking-exam-grading\/grading\/question\/item\/update$/,
  // 更新批阅痕迹、点击给分标记
  /^put:\/marking-exam-grading\/exam-grading\/mark$/,
]

async function init (appName = 'unknown') {
  window.SlsSend = send
  window.xjAppName = appName
  // 设置阿里云日志
  if (!window.yjSls) {
    const opts = {
      host: 'cn-hangzhou.log.aliyuncs.com',
      project: 'xkw-client-log',
      logstore: 'logstore-xkw-yuejuan',
      time: 10, // 发送日志的时间间隔，默认是10秒。
      count: 10, // 每次发送日志的数量大小，默认是10条。
      topic: '阅卷前端',// 自定义日志主题。
      tags: {
        appName: appName,
        initTime: new Date().toLocaleString(),
        lastInitTime: localStorage.getItem(appName + 'InitTime'),
        env: process.env.NODE_ENV
      }
    }
    localStorage.setItem(appName + 'InitTime', opts.tags.initTime)
    try {
      const newSlsTracker = new SlsTracker(opts)
      const stsOpt = await baseApi.getSlsToken()
      const stsPlugin = createStsPlugin(stsOpt)
      newSlsTracker.useStsPlugin(stsPlugin)
      window.yjSls = newSlsTracker
    } catch (error) {
      window.yjSls = null
    }
  }
  return window.yjSls
}

function send (data = { key: 'default' }) {
  if (window.yjSls) {
    // 检查token是否有效
    data.href = location.href
    data.browser = getBrowserInfo()
    // 获取用户信息
    const { nickName, schoolName, userId, schoolId } = store.getters.getUserInfo
    data.user = {
      userId,
      schoolId,
      schoolName,
      nickName
    }
    // 获取版本信息
    const version = localStorage.getItem(window.xjAppName + 'BuildVersion')
    if (version) {
      const dict = JSON.parse(version)
      data.version = dict.packageVersion
      data.buildTime = new Date(dict.buildTime).toLocaleString()
    }
    if (data['log_level']) {
      data['log_level'] = data['log_level'].toUpperCase()
    } else {
      data['log_level'] = 'INFO'
    }
    window.yjSls.sendImmediate(data)
  } else {
    console.debug('window.yjSls is not initialized')
  }
}

function reInit () {
  if (window.yjSls) {
    window.yjSls = null
    window.SlsSend = null
  }
  init('school')
}

// 添加统一的错误日志打印函数
function httpLog (action, desc, resp) {
  const info = {
    action,
    desc: desc
  }
  info['log_level'] = 'INFO'
  if (resp.headers) {
    info.headers = resp.headers
  }
  if (resp.message) {
    info.message = resp.message
  }
  if (resp.stack) {
    info.stack = resp.stack
  }
  const config = resp.config || {}
  if (config) {
    const { url, method, data, params, headers, progress } = config
    info.api = url
    info.headers = headers
    info.method = method
    if (data || params) {
      info.params = data || params
    }
    // 请求进度
    if (progress) {
      info.progress = progress
    }
  }
  const response = resp.response || resp
  if (action.indexOf('HTTP_REQUEST') === -1 && response) {
    if (action.indexOf('HTTP_SUCCESS') === -1) {
      info.resp = response.data
      info['log_level'] = 'ERROR'
    }
    info.status = response.status
    info.statusText = response.statusText
  }
  // console.log('sls info', info)
  send(info)
}

function checkSlsUrl (method, url) {
  if (typeof url !== 'string') return false
  const key = `${method}:${url.replace(domain, '')}`
  return slsUrls.some(regex => regex.test(key))
}

function getBrowserInfo () {
  return {
    userAgent: navigator.userAgent.toLowerCase(),
    platform: navigator.platform.toLowerCase(),
    screen: {
      width: window.screen.width,
      height: window.screen.height,
      colorDepth: window.screen.colorDepth,
      pixelRatio: window.devicePixelRatio || 1
    },
    isOnline: navigator.onLine,
    connection: navigator.connection
  }
}

function getRequestId () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
} 